import { CardClient } from '@atlaskit/link-provider';
import { atlassianApiGateway } from '@trello/config';
import { SharedState } from '@trello/shared-state';

import { assertSupportedUrlPattern } from './assertSupportedUrlPattern';

export type SmartCardClientResponse = Awaited<
  ReturnType<CardClient['fetchData']>
>;

interface CustomCardClient extends CardClient {
  isCached: (url: string) => boolean;
  authorizedProviders: SharedState<Set<string>>;
}

class SmartCardClient extends CardClient implements CustomCardClient {
  public isCached = () => false;
  public authorizedProviders = new SharedState(new Set<string>());
  public async prefetchData(url: string) {
    assertSupportedUrlPattern(url);
    return super.prefetchData(url);
  }
  public async fetchData(url: string, force?: boolean) {
    assertSupportedUrlPattern(url);
    return super.fetchData(url, force);
  }
}

const envKey = undefined;
const baseUrlOverride = `${atlassianApiGateway}gateway/api`;

// eslint-disable-next-line @trello/no-module-logic
export const smartCardClient: CustomCardClient = new SmartCardClient(
  envKey,
  baseUrlOverride,
);
